import {isNotEmpty, join, splitEvery} from 'ramda';

const DATA_GRIDS_PARAM = 'dataGrids';
const PAGE_PARAM = 'page';
const GRID_ENTRY_SEPARATOR = '|';
const GRID_ENTRY_SIZE = 3;

const setOrDeleteParam = (params: URLSearchParams, key: string, value: string) =>
  isNotEmpty(value) ? params.set(key, value) : params.delete(key);

// `dataGrids` holds `gridCode,queryId,rowIndex` entries: the eag-grid ends each with `|`, the
// legacy datagrid joins them with `,`. The eag-grid also keeps `gridCode:page` entries in `page`.
export const getSearchWithoutGrid = (search: string, gridCode: string) => {
  const params = new URLSearchParams(search);
  const dataGrids = params.get(DATA_GRIDS_PARAM) ?? '';
  const isPipeFormat = dataGrids.includes(GRID_ENTRY_SEPARATOR);
  const entries = isPipeFormat
    ? dataGrids.split(GRID_ENTRY_SEPARATOR)
    : splitEvery(GRID_ENTRY_SIZE, dataGrids.split(',')).map(join(','));
  const otherEntries = entries.filter(
    (entry) => isNotEmpty(entry) && entry.split(',')[0] !== gridCode
  );
  const pages = (params.get(PAGE_PARAM) ?? '').split(',');
  const otherPages = pages.filter((page) => isNotEmpty(page) && !page.startsWith(`${gridCode}:`));

  const dataGridsValue = isPipeFormat
    ? otherEntries.map((entry) => entry + GRID_ENTRY_SEPARATOR).join('')
    : otherEntries.join(',');

  setOrDeleteParam(params, DATA_GRIDS_PARAM, dataGridsValue);
  setOrDeleteParam(params, PAGE_PARAM, otherPages.join(','));
  return params;
};
